import React from 'react';
import { CheckCircle2 } from 'lucide-react';

export const DemoRequestSuccess = ({ request, copy }) => <div className="flex h-full flex-col items-center justify-center py-16 text-center" data-testid="demo-success">
  <CheckCircle2 className="h-14 w-14 text-emerald-500" />
  <h3 data-testid="demo-success-title" className="mt-5 text-xl font-bold text-slate-900">{copy.successTitle}</h3>
  <p data-testid="demo-success-details" className="mt-2 max-w-xs text-[15px] text-slate-600">{copy.successText.replace('{name}', request.form.full_name.split(' ')[0])}</p>
  <button data-testid="demo-submit-another" onClick={request.reset} className="mt-6 text-sm font-semibold text-blue-700 hover:text-blue-800">{copy.submitAnother}</button>
</div>;